import { Component, OnInit, inject } from '@angular/core';

import { RouterLink } from '@angular/router';
import { PageTitleService } from '../../core/services/page-title.service';
import { InoutService } from '../../core/services/inout.service';
import { MemberApiService } from '../../core/services/member-api.service';
import { PtReservationService } from '../../core/services/pt-reservation.service';

@Component({
    selector: 'app-top',
    imports: [RouterLink],
    templateUrl: './top.component.html'
})
export class TopComponent implements OnInit {
  private pageTitle = inject(PageTitleService);
  private inoutService = inject(InoutService);
  private memberApi = inject(MemberApiService);
  private ptReservation = inject(PtReservationService);

  isConfiguredQR = false;
  isCounselable = false;
  reservationGlobalFlag = false;

  async ngOnInit(): Promise<void> {
    this.pageTitle.set('', 'トップ');
    this.isConfiguredQR = await this.inoutService.isConfiguredQr();
    const member = await this.memberApi.getOne('self');
    this.isCounselable = !!member?.studio?.isCounselable;
    const flag = await this.ptReservation.getGlobalFlag();
    this.reservationGlobalFlag = !!flag;
  }
}
